import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController'
import ConfigurationService from '../../services/configuration-service';
import { Inject } from '@odinjs/odin';
import { ImageAPI } from '@philips-internal/oswald-ui-components';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

@Controller({ component: 'root-layout', fragment: 'reset-password-request-failure-and-expired' })
class ResetPasswordRequestFailureController extends BaseController {

  @Inject('header-image')
    ImageHeader!: ImageAPI;

  @OnClick({ target: ['failure-ok-button'] })
  onClickLoginButton(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

  @OnMount({ target: ['root-layout'] })
  onMount(): void {
    ConfigurationService.getConfigurationData().then(layoutData => {
      this.ImageHeader.setSrc(layoutData.dsUrlLogoHeaderLogin);
    })
  }
}

export default ResetPasswordRequestFailureController;
